<template>
  <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
    <feather-icon
      icon="Edit3Icon"
      title="Edit Resource"
      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
      @click="editRecord(params.data)"
    />
    <feather-icon
      icon="Trash2Icon"
      title="Delete Resource"
      svgClasses="h-5 w-5 mr-4 hover:text-danger cursor-pointer"
      @click="beforeDeleteRecord(params.data)"
    />
    <span
      class="feather-icon select-none relative switch-publish"
      title="Publish / Un-Publish"
    >
      <vs-switch v-model="params.data.IsPublished"> </vs-switch>
    </span>

    <!-- <span
      class="feather-icon select-none relative switch-publish ml-4"
      title="Pin / Un-Pin Resource"
    >
      <vs-switch v-model="params.data.IsPinned"> </vs-switch>
    </span> -->

    <vs-popup
      class="holamundo resource-edit-pop"
      title="Edit Resource"
      :active.sync="popupActiveEditResource"
    >
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mt-2">
          <label>Resource Name</label>
          <vs-input
            class="w-full mb-3"
            name="ResourceName"
            data-vv-as="Resource Name"
            v-model="editedResourceName"
            v-validate="'required'"
          />
          <span class="text-danger text-sm" v-show="errors.has('ResourceName')">{{
            errors.first("ResourceName")
          }}</span>
        </div>

        <div class="vx-col md:w-1/2 w-full mt-2">
          <label>Category</label>
          <v-select
            class
            label="Category"
            :options="editedCategoryData"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="editedSelectedCategory"
          />
        </div>
      </div>
      <label>Short Description</label>
      <textarea
        class="w-full"
        name="description"
        cols="40"
        rows="3"
        v-model="editedDescription"
      ></textarea>
     
      <div class="mt-3">
        <label>Type</label>
        <br/>
        <br/>
        <vs-radio
          v-model="editedResourceType"
          vs-value="pdf"
          class="mr-4"
          vs-name="theme-mode-light"
          disabled
          >PDF</vs-radio
        >
        <vs-radio
          v-model="editedResourceType"
          vs-value="video"
          class="mr-4"
          vs-name="theme-mode-dark"
          disabled
          >Video URL</vs-radio
        >
        <vs-radio
          v-model="editedResourceType"
          vs-value="image"
          class="mr-4"
          vs-name="theme-mode-semi-dark"
          disabled
          >Image</vs-radio
        >
        <vs-radio
          v-model="editedResourceType"
          vs-value="code"
          class="mr-4"
          vs-name="theme-mode-semi-dark"
          disabled
          >Embed Code</vs-radio
        >
        <vs-radio
          v-model="editedResourceType"
          vs-value="hyperLink"
          class=""
          vs-name="theme-mode-semi-dark"
          >Hyper Link</vs-radio
        >
      </div>
      <div
        class="vx-col md:w-12/12 w-full"
        v-if="
          editedResourceType == 'pdf' ||
          editedResourceType == 'video' ||
          editedResourceType == 'hyperLink'
        "
      >
        <div class="label-top">
          <label>Upload Cover Image</label>
          <!-- <div class="label-info">
            <feather-icon class="" icon="InfoIcon" title="Info Icon" />
            <div class="image-hotspot-info">
              <p>
                Booth hotspot image should be transparent PNG file 1170 x 600px.
                Please don't make any structural changes. Use the PSD source
                file, you may change the colors, icons etc keeping the same
                propotions. This is to ensure the file is compatible with the
                hotspot zones in the template.
              </p>
            </div>
          </div> -->
        </div>
        <div class="hotspot-imagelink-box-wrap">
          <vs-input
            class="inputx w-full"
            name="editedCoverImageURL"
            v-model="editedCoverImageURL"
          />
          <vs-button
            color="primary"
            type="filled"
            @click="$refs.upload_image.click()"
            size="small"
            class="upload-btn"
            >Upload</vs-button
          >
        </div>
        <div class="hotspot-image-box-wrapper">
          <img
            class="mr-2 rounded"
            v-show="editedCoverImageURL"
            :src="editedCoverImageURL"
          />
        </div>
        <input
          class="hidden"
          ref="upload_image"
          type="file"
          @change="
            UploadImage($event, 'editedCoverImageURL', 'editedCoverImageURL')
          "
          accept="image/*"
        />
      </div>
      <br />
      <div class="upload-file" v-if="editedResourceType == 'pdf'">
        <div class="single-file-wrap" v-if="editedResourcePath">
          <div class="file-sec-wrap">
            <a
              :href="editedResourcePath.name ? '#' : editedResourcePath"
              target="_blank"
              >{{
                editedResourcePath.name
                  ? editedResourcePath.name
                  : getFileName(editedResourcePath)
              }}</a
            >
            <a href="#"
              ><img
                @click="deleteFile()"
                src="../../../assets/images/delete.svg"
            /></a>
          </div>
        </div>
        <div class="file-up-section" v-if="showResourceUpload">
          <p>Upload PDF file</p>
          <input type="file" id="pdf_file1" accept=".pdf" />
          <vs-button
            color="rgb(76, 139, 246)" type="filled"
            class="sub-btn"
            v-on:click="uploadResourceFiles"
            >Upload</vs-button
          >
        </div>
      </div>
      <div class="upload-file" v-else-if="editedResourceType == 'image'">
        <div class="single-file-wrap" v-if="editedResourcePath">
          <div class="file-sec-wrap">
            <a
              :href="editedResourcePath.name ? '#' : editedResourcePath"
              target="_blank"
              >{{
                editedResourcePath.name
                  ? editedResourcePath.name
                  : getFileName(editedResourcePath)
              }}</a
            >
            <a href="#"
              ><img
                @click="deleteFile()"
                src="../../../assets/images/delete.svg"
            /></a>
          </div>
        </div>
        <div class="file-up-section" v-if="showResourceUpload">
          <p>Upload Image file</p>
          <input type="file" id="image_file1" accept=".jpg,.png,.gif" />
          <vs-button
            color="rgb(76, 139, 246)" type="filled"
            class="sub-btn"
            v-on:click="uploadResourceFiles"
            >Upload</vs-button
          >
        </div>
      </div>
      <div class="upload-file" v-else-if="editedResourceType == 'code'">
        <div class="file-up-section">
          <p>Paste Your Embed Code</p>
          <textarea
            class="mt-5 w-full"
            name="embedCode"
            cols="40"
            rows="6"
            v-model="editedEmbedCode"
          ></textarea>
        </div>
      </div>
      <div class="upload-file" v-else-if="editedResourceType == 'video'">
        <div
          class="single-file-wrap"
          v-if="editedResourceType && showVideoLink == false"
        >
          <div class="file-sec-wrap">
            <a
              :href="editedResourcePath.name ? '#' : editedResourcePath"
              target="_blank"
              >{{
                editedResourcePath.name
                  ? editedResourcePath.name
                  : getFileName(editedResourcePath)
              }}</a
            >
            <a href="#"
              ><img
                @click="deleteFile()"
                src="../../../assets/images/delete.svg"
            /></a>
          </div>
        </div>
        <div
          class="file-up-section"
          v-if="showResourceUpload || showVideoLink == true"
        >
          <div class="vx-col md:w-3/3 w-full mt-2">
            <div class="label-top">
              <label>Embed Video Link(Youtube or Vimeo)</label>
              <div class="label-info">
                <feather-icon class="" icon="InfoIcon" title="Info Icon" />
                <div class="video-embed-custom-tooltip">
                  <img
                    src="../../../assets/images/video-embed.jpg"
                    alt="video-embed"
                  />
                </div>
              </div>
            </div>
            <vs-input
              class="inputx w-full"
              name="videoLink"
              v-model="editedVideoLink"
            />
          </div>
          <p>OR</p>
          <p>Upload your video(Max Size: 100 mb)</p>
          <input type="file" id="video_file1" accept=".mp4" />
          <vs-button
            color="rgb(76, 139, 246)" type="filled"
            class="sub-btn"
            v-on:click="uploadResourceFiles"
            >Upload</vs-button
          >
        </div>
      </div>
      <div class="upload-file" v-else-if="editedResourceType == 'hyperLink'">
        <div class="file-up-section">
          <p>Paste Resource HyperLink(Opens in new tab)</p>
          <vs-input
            class="mt-5 w-full"
            name="resourceHyperLink"
            v-model="editedResourceHyperLink"
          />
        </div>
      </div>
      <br />
      <vs-button class="mr-6" v-on:click="saveEditedResource">Submit</vs-button>
      <vs-button
        type="border"
        color="danger"
        @click="popupActiveEditResource = false"
        >Cancel</vs-button
      >
    </vs-popup>
  </div>
</template>

<script>
import moment from "moment-timezone";
import moduleResourceManagement from "@/store/resource-management/moduleResourceManagement.js";
import vSelect from "vue-select";
import ls from "@/common/localStorage";
let Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");
var cn = ls.getSessionEventCollectionName();
import Swal from "sweetalert2";
var vm;
export default {
  name: "CellRendererActions",
  components: {
    vSelect,
  },
  data() {
    return {
      popupActiveEditResource: false,
      editedResourceName: null,
      editedDescription: null,
      editedResourceType: null,
      editedCoverImageURL: null,
      editedCategoryData: [],
      editedSelectedCategory: null,
      editedResourcePath: null,
      showResourceUpload: false,
      editedUploadedResourcePath: null,
      editedEmbedCode: null,
      showVideoLink: false,
      editedVideoLink: null,
      allCategoryList: [],
      editedFileName: null,
      editedResourceHyperLink: null,
    };
  },
  watch: {
    "params.data.IsPublished"() {
      this.$store
        .dispatch("resourceManagement/updateStatus", {
          id: this.params.Id,
          IsPublished: this.params.data.IsPublished,
        })
        .then(() => {
          this.showChangeStatusSuccess();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    // "params.data.IsPinned"() {
    //   this.$store
    //     .dispatch("resourceManagement/updatePinnedStatus", {
    //       id: this.params.Id,
    //       IsPinned: this.params.data.IsPinned,
    //     })
    //     .then(() => {
    //       this.showChangeStatusSuccess();
    //     })
    //     .catch((err) => {
    //       console.error(err);
    //     });
    // },
  },
  methods: {
    editRecord(data) {
      this.editedResourceName = data.ResourceName;
      this.editedDescription = data.Description;
      if (data.SelectedCategory[0] != undefined) {
        this.editedSelectedCategory = data.SelectedCategory[0].Name;
      }
      this.editedResourceType = data.ResourceType;
      this.editedCoverImageURL = data.CoverImageURL;
      this.editedResourcePath = data.ResourcePath;
      this.editedEmbedCode = data.EmbedCode;
      this.editedFileName = data.FileName;
      if (this.editedResourcePath == "") {
        this.showResourceUpload = true;
      }
      if (this.editedResourceType == "video") {
        if (this.editedResourcePath.includes("firebasestorage")) {
          this.showVideoLink = false;
        } else {
          this.editedVideoLink = this.editedResourcePath;
          this.showVideoLink = true;
        }
      }
      if (this.editedResourceType == "hyperLink") {
        this.editedResourceHyperLink = data.HyperLinkUrl;
      }
      this.fetchCategoryDataForEdit();
      this.popupActiveEditResource = true;
    },
    fetchCategoryDataForEdit() {
      this.$store
        .dispatch("resourceManagement/fetchCategory")
        .then((res) => {
          this.editedCategoryData = [];
          res.map((row) => {
            row.ModifiedTime = this.SetTimeByZone(
              new Date(row.CreatedTime.seconds * 1000).toUTCString(),
              Session_Event_TZ
            );
            this.editedCategoryData.push(row.Name);
          });
          this.allCategoryList = res;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    showChangeStatusSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Status Changed",
        text: "Status changed successfully",
      });
    },
    UploadImage(input, fieldName, fieldsrc) {
      // You can update avatar Here
      if (input.target.files && input.target.files[0]) {
        const bgImgfile = input.target.files[0];
        const metadata = { contentType: bgImgfile.type };
        const validImageTypes = ["image/jpeg", "image/png"];
        if (!validImageTypes.includes(bgImgfile.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        let FileSize = bgImgfile.size / 1024 / 1024;
        if (FileSize > 10) {
          alert("Uploaded file size exceeds 10 MB");
          return false;
        }
        //this.data_local[fieldName] = bgImgfile;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.uploadFile(bgImgfile, fieldName, fieldsrc);
          //this[fieldsrc] = e.target.result;
        };

        reader.readAsDataURL(input.target.files[0]);
      }
    },
    uploadFile(file, fieldName, fieldsrc) {
      this.$vs.loading();
      this.$store
        .dispatch("resourceManagement/uploadFiles", {
          file: file,
          path: cn + "/Resources/",
        })
        .then((res) => {
          this.$vs.loading.close();
          this.editedCoverImageURL = res;
        })
        .catch((err) => {
          //console.error(err)
          this.$vs.loading.close();
        });
    },
    getFileName(downloadUrl) {
      let url = decodeURIComponent(downloadUrl);
      let arr = url.split("?");
      let arr2 = arr[0].split("/");
      let name = arr2[arr2.length - 1];
      return name;
    },
    deleteFile() {
      this.$vs.loading();
      const Id = this.params.Id;
      if (Id) {
        this.$store
          .dispatch("resourceManagement/removeResourceFromEdit", {
            id: Id,
          })
          .then(() => {
            this.editedResourcePath = null;
            this.showResourceUpload = true;
            this.showVideoLink = true;
            this.editedFileName = null;
            this.$vs.loading.close();
          })
          .catch((err) => {
            this.$vs.loading.close();
            console.error(err);
          });
      }
    },
    uploadResourceFiles() {
      let FileSize;
      if (this.editedResourceType == "pdf") {
        var pdfFile1 = document.getElementById("pdf_file1").files;
        FileSize = pdfFile1[0].size / 1024 / 1024;
        if (FileSize > 20) {
          alert("Uploaded file size exceeds 20 MB");
          return false;
        } else {
          this.editedFileName = pdfFile1[0].name;
          this.uploadEditedResource(pdfFile1[0], "/Resources/pdfs/");
        }
      } else if (this.editedResourceType == "image") {
        var imageFile1 = document.getElementById("image_file1").files;
        FileSize = imageFile1[0].size / 1024 / 1024;
        if (FileSize > 10) {
          alert("Uploaded file size exceeds 10 MB");
          return false;
        } else {
          this.editedFileName = imageFile1[0].name;
          this.uploadEditedResource(imageFile1[0], "/Resources/images/");
        }
      } else if (this.editedResourceType == "video") {
        var videoFile1 = document.getElementById("video_file1").files;
        FileSize = videoFile1[0].size / 1024 / 1024;
        if (FileSize > 100) {
          alert("Uploaded file size exceeds 100 MB");
          return false;
        } else {
          this.editedFileName = videoFile1[0].name;
          this.uploadEditedResource(videoFile1[0], "/Resources/video/");
        }
      }
    },
    uploadEditedResource(file, path) {
      this.$vs.loading();
      this.$store
        .dispatch("resourceManagement/uploadFiles", {
          file: file,
          path: cn + path,
        })
        .then((res) => {
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Resource",
            text: "Resource Uploaded Successfully.",
          });
          this.editedResourcePath = res;
          this.showResourceUpload = false;
          this.showVideoLink = false;
          this.$vs.loading.close();
        })
        .catch((err) => {
          this.$vs.loading.close();
        });
    },
    saveEditedResource() {
      if ((this.editedResourceType = "video")) {
        if (this.editedVideoLink != null) {
          this.editedResourcePath = this.editedVideoLink;
        }
      }
      if (
        this.editedResourcePath == null &&
        this.editedEmbedCode == "" &&
        this.editedVideoLink == "" &&
        this.editedResourceHyperLink == null
      ) {
        alert("Resource Not Uploaded");
      } else {
        this.$vs.loading();
        var category = [];
        this.allCategoryList.map((row1) => {
          if (row1.Name == this.editedSelectedCategory) {
            category.push({
              Id: row1.Id,
              Name: row1.Name,
            });
          }
        });
        this.$store
          .dispatch("resourceManagement/updateResources", {
            id: this.params.Id,
            resourceName: this.editedResourceName,
            description: this.editedDescription,
            selectedCategory: category,
            resourceType: this.editedResourceType,
            coverImageURL: this.editedCoverImageURL,
            uploadedResourcePath: this.editedResourcePath,
            embedCode: this.editedEmbedCode,
            fileName: this.editedFileName,
            hyperLinkUrl: this.editedResourceHyperLink,
          })
          .then((res) => {
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Resources",
              text: "Resource Updated successfully.",
            });
            this.popupActiveEditResource = false;
            this.editedResourceName = null;
            this.editedDescription = null;
            this.editedSelectedCategory = null;
            this.editedResourceType = null;
            this.editedCoverImageURL = null;
            this.editedResourcePath = null;
            this.editedVideoLink = null;
            this.editedEmbedCode = null;
            this.$vs.loading.close();
            //this.$router.push({ name: "resource" }).catch(() => {});
          })
          .catch((err) => {
            console.error(err);
            this.$vs.loading.close();
          });
      }
    },
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment
        .tz(strDateTime, timeZone)
        .format("MMM DD, YYYY hh:mm A");
      return date;
    },
    deleteResource(data){
       this.$vs.loading();
            this.$store
        .dispatch("resourceManagement/removeRecords", {
          data: data.Id,
        })
        .then((res) => {
          //alert(res.message)
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Delete",
            text: res.message,
          });
            this.$store.dispatch("resourceManagement/fetchAllResources");
          this.$vs.loading.close();
          
        })
        .catch((err) => {
          //console.error(err)
          this.$vs.loading.close();
        });
    },
    beforeDeleteRecord(data) {
        const { value: text } = Swal.fire({
          title: "Do you want to Delete these Resource's ?",
          input: "text",
          inputPlaceholder: "Type 'delete' and hit the Submit button",
          showCancelButton: true,
          confirmButtonText: "Submit",
          inputValidator: (value) => {
            if (value.toLocaleLowerCase().trim() == "delete") {
              this.deleteResource(data);
            } else {
              return "Try again! Please type 'delete' and hit Submit.";
            }
          },
        });
      
    },
  },
  created() {
    if (!moduleResourceManagement.isRegistered) {
      this.$store.registerModule(
        "resourceManagement",
        moduleResourceManagement
      );
      moduleResourceManagement.isRegistered = true;
    }
    this.fetchCategoryDataForEdit();
  },
};
</script>
<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
.image-hotspot-info {
  position: absolute;
  width: 423px;
  height: 167px;
  background: #ffff;
  z-index: 999;
  line-height: 25px;
  padding: 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.6);
  border-radius: 5px;
  bottom: 22px;
  left: 0;
  display: none;
}
.label-info:hover .image-hotspot-info {
  display: block;
}
.hotspot-imagelink-box-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
}
.hotspot-imagelink-box-wrap .vs-con-input {
  padding-right: 10px;
}
.hotspot-image-box-wrapper {
  width: 100%;
  height: 241px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border: 1px solid #dfdfdf;
  margin: 10px 0;
}
.hotspot-image-box-wrapper img {
  width: 100%;
}
.label-top {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.video-embed-custom-tooltip {
  position: absolute;
  z-index: 99999;
  width: 460px;
  height: 326px;
  padding: 15px;
  box-shadow: 0 0 7px rgba(0, 0, 0, 0.4);
  background: #fff;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  top: 13px;
  display: none;
}
.label-info:hover .video-embed-custom-tooltip {
  display: flex;
}
.file-sec-wrap {
  width: 100%;
  padding: 8px;
  border-radius: 5px;
  background: #e8e8e8;
  margin-bottom: 10px;
  display: inline-block;
}
.file-sec-wrap a {
  display: inline-block;
  vertical-align: middle;
}
.file-sec-wrap img {
  display: inline-block !important;
  vertical-align: middle;
  width: 20px;
  height: 20px;
}
.resource-edit-pop textarea {
    border: 1px solid #ccc;
    resize: none;
    height: 90px;
    border-radius: 5px;
}
</style>
